import { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [inCart, setInCart] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const addToCart = useCallback(() => {
    setInCart(true);
    setDrawerOpen(true);
  }, []);

  const removeFromCart = useCallback(() => setInCart(false), []);

  return (
    <CartContext.Provider
      value={{ inCart, drawerOpen, setDrawerOpen, addToCart, removeFromCart }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
